export default __webpack_public_path__ + "static/media/Malvie.7e23fa18.eot";